import { render } from "./ManageIntern.vue?vue&type=template&id=b8ddd496"
import script from "./ManageIntern.vue?vue&type=script&lang=js"
export * from "./ManageIntern.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__